import React from 'react';

import './index.scss';

export const RingPhone = () => {
  return (
    <div className="dial-pad-phone-ring-wrapper">
      <div className="circle" />
      <div className="fill" />
    </div>
  );
};

export default RingPhone;
